// @ts-nocheck

import { BezierItem } from "../interfaces/BezierItem";
import { toDegree, toRadians } from "../utils/utils";
import { DEFTYPES } from "../values/enums";

function Stops({ def }) {
  if (!def) {
    return null;
  }
  if (def.stops) {
    return (
      <>
        {def.stops.map((stop, i) => (
          <stop key={i} offset={stop.offset} stopColor={stop.stopColor} stopOpacity={stop.stopOpacity || 1} />
        ))}
      </>
    );
  } else if (def.colors) {
    return (
      <>
        {def.colors.map((color, i) => (
          <stop key={i} offset={i / (def.colors.length - 1)} stopColor={color} />
        ))}
      </>
    );
  }
}
function LinearGradient({ def }) {
  const props = { ...def };
  delete props.stops;
  props.gradientTransform = props.gradientTransform;
  let x1 = def.x1 || 0;
  let x2 = def.x2 || 0;
  let y1 = def.y1 || 0;
  let y2 = def.y2 || 0;

  if (def.angle) {
    x1 = 0;
    y1 = 1;
    x2 = Math.cos(toRadians(def.angle));
    y2 = Math.sin(toRadians(def.angle));
  }
  return (
    <linearGradient {...props} x1={x1} x2={x2} y1={y1} y2={y2}>
      <Stops def={def} />
    </linearGradient>
  );
}

function RadialGradient({ def }) {
  const props = { ...def };
  delete props.stops;
  props.gradientTransform = props.gradientTransform;
  return (
    <radialGradient {...props}>
      <Stops def={def} />
    </radialGradient>
  );
}

function ImportUrl({ def }) {
  return <style>@import url('{def.url}');</style>;
}
function Path({ def }) {
  return <path {...def} />;
}
function Marker({ def }) {
  const defWithoutChildren = { ...def, children: undefined };
  return (
    <marker def={defWithoutChildren}>
      {def.paths.map((path, i) => (
        <path key={i} {...path} />
      ))}
    </marker>
  );
}

function Pattern({ def }) {
  return (
    <g dangerouslySetInnerHTML={{ __html: def.pattern?.innerHTML }} />
  )
}

function SVGDef({ def }) {
  if (!def) return null;
  return (
    <>
      {def.type === DEFTYPES.LINEARGRADIENT && <LinearGradient def={def} />}
      {def.type === DEFTYPES.RADIALGRADIENT && <RadialGradient def={def} />}
      {def.type === DEFTYPES.IMPORTURL && <ImportUrl def={def} />}
      {def.type === DEFTYPES.CLIPPATH && <clipPath id={def.id} clipPathUnits={def.clipPathUnits} dangerouslySetInnerHTML={{ __html: def.innerHTML }}></clipPath>}
      {def.type === DEFTYPES.MARKER && <Marker def={def} />}
      {def.type === DEFTYPES.PATTERN && <Pattern def={def} />}
    </>
  );
}

export default SVGDef;
